/** Rejects an update-input object with no fields set — a patch must change something. */
export const requireAtLeastOneField = (schema) => schema.refine((input) => Object.values(input).some((value) => value !== undefined), {
    message: 'At least one field must be provided.',
});
//# sourceMappingURL=require-at-least-one-field.js.map